export const role = [
  { value: 2, label: "Hanay Admin" },
  { value: 3, label: "Hanay Employee" },
];

export const AggregatorRole = [
  { value: 4, label: "Aggregator Admin" },
  { value: 5, label: "Aggregator Employee" },
]

export const superAdminRole = [
  { value: 1, label: "Super Admin" },
]


